import { useTranslation } from 'react-i18next'
import { useCallback, useState } from 'react'
import { GenericDialog, InputGroup, Button } from '@/common'

export default function ProductionRouteRenameDialog({
  name,
  isOpen,
  close,
  onUpdate,
  isUpdating
}: {
  name: string
  isOpen: boolean
  close: () => void
  onUpdate: (name: string) => void
  isUpdating: boolean
}) {
  const { t } = useTranslation()
  const [nameState, setNameState] = useState(name)

  const onClose = () => {
    setNameState(name)
    close()
  }

  const onSubmit = useCallback(
    (evt: React.FormEvent<HTMLFormElement>) => {
      evt.preventDefault()
      if (nameState.length > 0) {
        onUpdate(nameState)
        close()
      }
    },
    [nameState, onUpdate, close]
  )

  return (
    <GenericDialog
      title={t('productionRoute:renameDialog.title')}
      size="md"
      isOpen={isOpen}
      close={onClose}
    >
      <form onSubmit={onSubmit} className="space-y-8">
        <InputGroup
          label={t('productionRoute:renameDialog.input.label')}
          value={nameState}
          onChange={(evt: React.ChangeEvent<HTMLInputElement>) => setNameState(evt.target.value)}
        />
        <footer className="gap-2 flex justify-end">
          <Button type="button" variant="neutral" disabled={isUpdating} onClick={onClose}>
            {t('common:actions.cancel')}
          </Button>
          <Button type="submit" disabled={!nameState || isUpdating} isLoading={isUpdating}>
            {t('common:actions.save')}
          </Button>
        </footer>
      </form>
    </GenericDialog>
  )
}
